import { render, staticRenderFns } from "./GanttComponent.vue?vue&type=template&id=58a8e52e&scoped=true&"
import script from "./GanttComponent.vue?vue&type=script&lang=js&"
export * from "./GanttComponent.vue?vue&type=script&lang=js&"
import style0 from "./GanttComponent.vue?vue&type=style&index=0&id=58a8e52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a8e52e",
  null
  
)

export default component.exports